import { Tenant } from 'apprise-core/tenant'
import { usePreload } from 'apprise-frontend-core/client/preload'
import { useIAMService } from 'apprise-frontend-iam/service'
import { useNewTenant, useTenantModel } from './model'



export const tenantApi = "/tenant"
export const tenantRefApi = "/tenantrefs"

export const useTenantClient = () => {

    const service = useIAMService()

    const {intern,extern} = useTenantModel()

    const newTenant = useNewTenant()

    const preload = usePreload()


    const self = {

         // come with no permissions, so won't need to be interned.
        fetchAllTenants: () => preload.get<Tenant[]>(tenantApi) ?? service.at(tenantApi).get<Tenant[]>()

        ,

        fetchAllRefs:  () : Promise<Tenant[]> => (preload.get<Tenant[]>(tenantRefApi) ?? service.at(tenantRefApi).get<Tenant[]>()).then(refs => refs.map(ref => ({...newTenant(), ...ref, lifecycle: {state:'active'}})))

        ,

        fetchOne: (id: string) =>  service.at(`${tenantApi}/${id}`).get<Tenant>().then(intern)

        ,

        add: (tenant:Tenant) =>  service.at(tenantApi).post<Tenant>(extern(tenant)).then(intern)
    
        ,
    
        update: (tenant:Tenant) => service.at(`${tenantApi}/${tenant.id}`).put<Tenant>(extern(tenant)).then(intern)
    
        , 

        delete: (id:string) => service.at(`${tenantApi}/${id}`).delete()
    }

    return self;

}
